import Config from '@/config'
import store from '@/store'
import { getDeviceId } from '@/utils/auth'
import clientLogger from '@/plugins/logger/core'
import LOGGING_EVENTS from '@/constants/logging-events'

const url = (route) => `${Config.kycApiBaseUrl}/${route}`

const kycUrl = (sessionId) => url(`customer/kyc/session/${sessionId}`)

const buildHeaders = () => {
  const deviceId = getDeviceId() || ''
  const locale = store.getters['kyc/locale'] || ''
  const kycToken = store.getters['kyc/kycToken'] || ''

  return {
    Authorization: kycToken ? `Bearer ${kycToken}` : '',
    'X-Device-Id': deviceId,
    'x-locale': locale,
  }
}

const postRequest = async (sessionId, bodyData) => {
  clientLogger.debug(LOGGING_EVENTS.KYC_API_REQUEST, {
    payload: { sessionId, ...bodyData },
  })
  const response = await fetch(kycUrl(sessionId), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...buildHeaders(),
    },
    body: JSON.stringify(bodyData),
  })
  clientLogger.debug(LOGGING_EVENTS.KYC_API_REQUEST, {
    response: { ...response },
  })
  return response.json()
}

const createRequestBody = (action, payload = {}) => ({
  action,
  additional: {
    seon_session: store.getters['kyc/kycSeonSession'] || '',
  },
  payload,
})

export default {
  fetch(sessionId) {
    return postRequest(sessionId, createRequestBody('query'))
  },
  submitData(sessionId, { data } = {}) {
    return postRequest(sessionId, createRequestBody('process', data))
  },
}
